import { Route } from "./Route"

export const populateRoute = (route: Route, ...args: string[]): string => {
  let populatedRoute = route as string
  for (const arg of args) {
    populatedRoute = populatedRoute.replace(/{.*?}/, arg)
  }
  return populatedRoute
}
